export const getFullPath = (pathname: string) => {
  const origin =
    typeof window !== "undefined" && window.location.origin
      ? window.location.origin
      : "";

  return `${origin}${pathname}`;
};
